import React from 'react';
import { colors } from '../theme';
import IProps from './interface';

const SpeakerIcon = ({ color, size, ...props }: IProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.9165 5.75001H2.33317C1.96517 5.75001 1.6665 6.04868 1.6665 6.41668V9.58334C1.6665 9.95134 1.96517 10.25 2.33317 10.25H3.9165L6.56917 12.4973C7.0025 12.8647 7.6665 12.5567 7.6665 11.9887V4.01134C7.6665 3.44334 7.00184 3.13534 6.56917 3.50268L3.9165 5.75001Z"
        stroke={color}
        strokeWidth={1.2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.3574 10.652C11.1321 10.1706 11.6661 9.16929 11.6661 8.00329C11.6661 6.83729 11.1321 5.83529 10.3574 5.34796"
        stroke={color}
        strokeWidth={1.2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.3368 12.71C13.5422 11.6733 14.3335 9.95332 14.3335 8.00198C14.3335 6.04798 13.5408 4.32665 12.3335 3.29065"
        stroke={color}
        strokeWidth={1.2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SpeakerIcon;
